import useWindowSize from "hooks/useWindowSize";
import { useAppSelector } from "slice";
import { useGetProfileStrengthQuery } from "slice/user";

export const useProfileStrength = () => {
    const { user_id } = useAppSelector((state) => state.userAuth);

    const windowSize = useWindowSize();

    const { data } = useGetProfileStrengthQuery(user_id, {
        skip: !user_id,
    });

    return {
        windowSize,
        data,
    };
};
